import type {
  FrameworkResponse,
  ReportResponse,
  SubmitReportRequest,
  SubmitReportResponse,
  WarsResponse,
} from '@dwa/shared';
import { request } from './client';

/** The catalog of available WARs (for the chooser + deep-link resolution). */
export const getWars = () => request<WarsResponse>('/wars');

/** A WAR's framework content (pillars + questions), served from DynamoDB. */
export const getFramework = (focus?: string) =>
  request<FrameworkResponse>(focus ? `/framework?focus=${encodeURIComponent(focus)}` : '/framework');

/** Submit the completed assessment + contact details; returns summary + reviewId. */
export const submitReport = (body: SubmitReportRequest) =>
  request<SubmitReportResponse>('/reports', { method: 'POST', body });

/** Fetch a shareable report by id (the emailed link). */
export const getReport = (reviewId: string) => request<ReportResponse>(`/reports/${reviewId}`);
